import { useMemo } from 'react';

// Виносимо стилі за межі компонента
const CSS_STYLES = `
  @font-face {
    font-family: 'Montserrat';
    font-display: swap;
  }

  .clinic-page {
    --mint: #1abc9c;
    --text-dark: #1e2d2a;
    background: radial-gradient(circle at top right, #f8fdfc, #e8f6f3);
    min-height: 100vh;
    padding: clamp(20px, 5vw, 60px) 15px;
    font-family: 'Montserrat', sans-serif;
    display: flex;
    justify-content: center;
    color: var(--text-dark);
  }

  .container { width: 100%; max-width: 1100px; }

  .header { 
    text-align: center; 
    margin-bottom: clamp(30px, 8vw, 60px); 
  }

  .content-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 420px), 1fr));
    gap: 30px;
    align-items: start;
  }

  .contact-card {
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    padding: clamp(25px, 5vw, 45px);
    border-radius: 30px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  }

  .map-section {
    position: relative;
    border-radius: 30px;
    overflow: hidden;
    background: #e0e0e0;
    height: 450px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  }

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
    display: block;
  }

  .phone-link {
    display: block;
    text-decoration: none;
    color: inherit;
    font-weight: 600;
    margin-bottom: 4px;
    transition: color 0.2s;
  }

  /* Додай це всередину CSS_STYLES */
  .email-link {
    display: inline-block;
    text-decoration: none;
    color: inherit;
    font-weight: 600;
    transition: color 0.2s;
  }

  .email-link:hover {
    color: var(--mint);
  }

  .phone-link:hover {
    color: var(--mint);
  }

  @media (max-width: 850px) {
    .map-section { order: -1; height: 350px; }
  }
`;

export default function ClinicPage() {
  // Посилання на карту з параметром hl=uk для української мови
// Додаємо параметр z=18 (масштаб), де 18-19 — це рівень окремих будівель
const MAP_URL = "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2538.8624700928676!2d30.469202!3d50.480903999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNTDCsDI4JzUxLjMiTiAzMMKwMjgnMDkuMSJF!5e0!3m2!1suk!2sua!4v1771244967616!5m2!1suk!2sua=uk&z=18";
  return (
    <div className="clinic-page">
      <style>{CSS_STYLES}</style>
      
      <div className="container">
        <header className="header">
          <h1 style={{ fontWeight: 800, fontSize: 'clamp(24px, 6vw, 40px)', margin: 0 }}>
            Ми завжди поруч
          </h1>
          <div style={{ width: 50, height: 4, background: 'var(--mint)', margin: '15px auto' }} />
          <p style={{ opacity: 0.8 }}>Ваш спокій починається тут</p>
        </header>

        <div className="content-grid">
          <div className="contact-card">
            <h2 style={{ fontSize: '24px', marginBottom: '30px', fontWeight: 700 }}>Контакти</h2>
            
            <ContactItem icon="📍" label="Адреса">
              <p style={{ margin: 0, fontWeight: 600 }}>м. Київ, вул. Кирилівська, 103</p>
            </ContactItem>

            <ContactItem icon="📞" label="Реєстратура">
              <a href="tel:0445038780" className="phone-link">(044) 503-87-80</a>
              <a href="tel:0956872590" className="phone-link">(095) 687-25-90</a>
            </ContactItem>

            {/* 🟢 Новий блок корпоративної пошти */}
<ContactItem icon="✉️" label="Пошта для звернень">
  <a href="mailto:info@eywa.clinic" className="email-link">
    info@eywa.clinic
  </a>
</ContactItem>

            <ContactItem icon="🕒" label="Графік роботи">
              <p style={{ margin: 0, fontWeight: 500 }}>
                Пн-Пт: 09:00 — 16:12<br />
                <span style={{ color: '#e74c3c' }}>Вихідні: Сб, Нд</span>
              </p>
            </ContactItem>
          </div>

          <div className="map-section">
            <iframe
              title="Локація клініки"
              src={MAP_URL}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ContactItem({ icon, label, children }: any) {
  return (
    <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
      <div style={{ 
        fontSize: '24px', 
        background: '#fff', 
        width: '50px', 
        height: '50px', 
        borderRadius: '15px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        boxShadow: '0 5px 15px rgba(0,0,0,0.03)'
      }}>
        {icon}
      </div>
      <div>
        <p style={{ 
          fontSize: '12px', 
          color: 'var(--mint)', 
          fontWeight: 700, 
          textTransform: 'uppercase', 
          letterSpacing: '1px',
          margin: '0 0 5px 0' 
        }}>
          {label}
        </p>
        <div style={{ fontSize: '16px', lineHeight: '1.5' }}>
          {children}
        </div>
      </div>
    </div>
  );
  
}
